// FinancialReleaseV2.js
import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import "../style/financial-release.css";
import { toArabicWord } from "number-to-arabic-words/dist/index-node.js";

export default function PartialPayment({ contractData }) {
  const storedUser = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin") || {})?.admin
  );
  function convertDateFormat(inputDate, local) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };

    const formattedDate = dateObject.toLocaleDateString(local, options);
    return formattedDate;
  }
  const currDate = new Date();

  const receiptAmount =
    contractData?.amount !== undefined && contractData?.amount !== null
      ? contractData.amount
      : contractData?.payment !== undefined && contractData?.payment !== null
      ? contractData.payment
      : contractData?.recent_payment !== undefined && contractData?.recent_payment !== null
      ? contractData.recent_payment
      : contractData?.total_paid;

  const isInvestorPayment =
    Boolean(contractData?.for_investor) ||
    contractData?.to_investor === "yes" ||
    contractData?.to_investor === true ||
    contractData?.to_investor === "1" ||
    contractData?.to_investor === 1;

  return (
    <div className="fr2-wrap p-4" dir="rtl">
      {/* Top pill title (no transforms; uses flex so it exports cleanly) */}
      {!isInvestorPayment && <div className="mb-4" dir="rlt">
        <div className="mx-1">{storedUser?.branch_name}</div>
        <div className="mx-1">سجل تجاري {storedUser?.valid_id_number}</div>
        <div className="mx-1">رقم الجوال {storedUser?.contact_number}</div>
      </div>}
      <div className="fr2-title-row mt-4">
        <div className="fr2-title bg-white">سند قبض</div>
      </div>

      {/* Rounded sheet */}
      <div className="fr2-sheet">
        {/* subtle top decorative band to mimic the reference curve */}

        <div className="container-fluid px-4">
          {/* Row: date (left) + amount box (right) */}
          <div className="row mt-3">
            <div className="col-6 d-flex justify-content-start">
              <div className="fr2-amount text-center">المبلغ: {receiptAmount} ريال </div>
            </div>
            <div className="col-6 d-flex justify-content-end">
              <div className="fr2-datelist lh-lg">
                <div>التاريخ: {convertDateFormat(currDate, "ar-SA")}</div>
                <div>الموافق: {convertDateFormat(currDate)}</div>
              </div>
            </div>
          </div>

          {/* Right text block */}
          <div className="row mt-4">
            <div className="">
              <div className="fr2-bodytext">
                <div className="mb-2">
                  <span className="mx-1"></span>استلمنا من المكرم /{" "}
                  {contractData?.user_name}
                </div>
                <div className="mb-2">
                  بمبلغ وقدره  /{" "}
                  {toArabicWord(receiptAmount || 0)} ريال
                </div>
                <div className="mb-2">
                  طريقة الدفع: {contractData?.paymentMethod}
                </div>
                <div className="mb-2">وذلك عن: {contractData?.description || ""}</div>
                <div className="mb-2">
                  لدى {
                    isInvestorPayment ? (contractData?.investor_name || contractData?.investor) : contractData?.branch_name
                  }
                </div>
              </div>
            </div>
          </div>

          {/* 4-column table */}
          <div className="row justify-content-center mt-4">
            <div className="col-11">
              <div className="table-responsive">
                <table className="table table-bordered fr2-table text-center align-middle mb-0">
                  <thead>
                    <tr>
                      <th>رقم العقد</th>
                      <th>قيمة العقد</th>
                      <th>المدفوع</th>
                      <th>الخصم</th>
                      <th>المتبقي</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{contractData?.contract_id * 9999}</td>
                      <td style={{ height: 56 }}>
                        {contractData?.total_value}
                      </td>
                      <td>{contractData?.total_paid}</td>
                      <td>{contractData?.discount || 0}</td>
                      <td>
                        {contractData?.total_value -
                          contractData?.total_paid -
                          (contractData?.discount || 0)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Footer: stamp & receiver signature */}
          <div className="row mt-5 pt-3">
            <div className="col-6">
              <div className="fw-semibold">توقيع المستلم</div>
            </div>
            <div className="col-6">
              <div className="fw-semibold">الختم</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
